import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Equalizer,
  ArrowForwardIos,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "lowercase",
  },
  btn2: {
    textTransform: "lowercase",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function System(props) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}
      <Box display="flex" alignItems="center">
        <Box mr={2}>
          {" "}
          <Equalizer color="primary" fontSize="large" />
        </Box>
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h5">
            <b>Reports</b>
          </Typography>
          <Box ml={1} mr={1} mt={1}>
            <ArrowForwardIos fontSize="small" />
          </Box>
          <Typography variant="h6">System</Typography>
        </Box>
      </Box>
      <Box mt={3} />
      <Paper style={{ padding: 50 }} elevation={0}></Paper>
    </div>
  );
}

const SystemReport = withLocalize(System);
export { SystemReport };
